import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import {
  getOrders,
  getOpenOrders,
  deleteOrder,
} from "../../../../Service/admin.service";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";
import Swal from "sweetalert2";
import DeltaSocketClient from "../../../../Utils/main/DeltaSocket";
import { EditOpenOrderPrice } from "../../../../Service/user.service";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { usePrices } from "../../../../context/PriceContext";

const safeFormatDateTime = (value) => {
  try {
    return value ? fDateTimeSuffix(value) : "—";
  } catch {
    return "—";
  }
};

const Orders = () => {
  const token = JSON.parse(localStorage.getItem("user_details"))?.token;
  const prices = usePrices(); // ✅ FIXED

  const [ordersData, setOrdersData] = useState({ loading: true, data: [] });
  const [originalData, setOriginalData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [strategy, setStrategy] = useState("");
  const [availableStrategies, setAvailableStrategies] = useState([]);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [refresh, setRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const [selectedUser, setSelectedUser] = useState("");
  const [availableUsers, setAvailableUsers] = useState([]);


  // const [editingPriceId, setEditingPriceId] = useState(null);
  // const [editPriceValue, setEditPriceValue] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);


  const [editingPriceId, setEditingPriceId] = useState(null);
  const [editPriceValue, setEditPriceValue] = useState("");
  const [originalPrice, setOriginalPrice] = useState(null);

  const roundSmart = (num, decimals = 2) =>
    num !== null && num !== undefined ? parseFloat(num).toFixed(decimals) : "-";

  const handlePriceEdit = (id, price) => {
    setEditingPriceId(id);
    setEditPriceValue(price ? price.toString() : "");
    setOriginalPrice(price || ""); // store original
  };

  // ✅ Cancel edit (show toast + revert)
  const handleCancelEdit = () => {
    setEditPriceValue(originalPrice || "");
    setEditingPriceId(null);
    toast("Edit cancelled", { icon: "❌" });
  };


  const handleSavePrice = async (orderId) => {
    if (!editPriceValue || isNaN(editPriceValue) || parseFloat(editPriceValue) <= 0) {
      alert("Please enter a valid price greater than 0");
      return;
    }

    setUpdateLoading(true);
    try {
      const response = await EditOpenOrderPrice({ _id: orderId, price: parseFloat(editPriceValue) }, token);

      if (response?.status) {
        setOrdersData((prevState) => ({
          ...prevState,
          data: prevState.data.map((order) =>
            order._id === orderId ? { ...order, price: parseFloat(editPriceValue) } : order
          ),
        }));
        toast.success("Price updated successfully!");
        setEditingPriceId(null);
        setEditPriceValue("");
      } else {
        alert(`Error: ${response?.message || "Failed to update price"}`);
      }
    } catch (error) {
      alert(`Network Error: ${error.message || "Please try again"}`);
    } finally {
      setUpdateLoading(false);
    }
  };

  const extractStrategies = (data) => {
    const strategies = [
      ...new Set(data.map((item) => item.strategy).filter(Boolean)),
    ];
    return strategies.sort();
  };

  const extractUsers = (data) => {
    const users = [
      ...new Set(
        data.map((item) =>
          item?.userData?.UserName || item?.userInfo?.UserName || "ADMIN"
        )
      ),
    ];
    return users.sort();
  };


  const applyFilters = (data, searchTerm, selectedStrategy, selectedUser) => {
    let filtered = data;

    if (selectedStrategy) {
      filtered = filtered.filter((item) => item.strategy === selectedStrategy);
    }

    if (selectedUser) {
      filtered = filtered.filter(
        (item) =>
          (item?.userData?.UserName || item?.userInfo?.UserName || "ADMIN") ===
          selectedUser
      );
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          (item.symbol || "").toLowerCase().includes(term) ||
          (item.side || "").toLowerCase().includes(term) ||
          (item.strategy || "").toLowerCase().includes(term) ||
          (item.status || "").toLowerCase().includes(term) ||
          (String(item.price) || "").toLowerCase().includes(term) ||
          (item.category || "").toLowerCase().includes(term)
      );
    }

    return filtered;
  };


  const columns = [
    {
      name: "Date",
      selector: (row) => row.createdAt,
      cell: (row) => <div>{safeFormatDateTime(row.createdAt)}</div>,
      sortable: true,
      width: "150px",
    },

    {
      name: "Symbol",
      selector: (row) => row.symbol,
      cell: (row) => <div>{row.symbol || "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Side",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="badge bg-success" style={{ fontSize: "0.9rem" }}>BUY</span>
        ) : (
          <span className="badge bg-danger" style={{ fontSize: "0.9rem" }}>SELL</span>
        ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Price",
      selector: (row) => row.price,
      cell: (row) =>
        activeTab === "open" ? (
          editingPriceId === row._id ? (
            <div className="d-flex align-items-center gap-1">
              <input
                type="text"
                value={editPriceValue}
                onChange={(e) => setEditPriceValue(e.target.value)}
                className="form-control form-control-sm"
                style={{ width: "100px" }}
                disabled={updateLoading}
              />
              <button
                className="btn btn-success btn-sm p-1"
                onClick={() => handleSavePrice(row._id)}
                disabled={updateLoading}
              >
                {updateLoading ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : (
                  <i className="bi bi-check"></i>
                )}
              </button>
              <button
                className="btn btn-secondary btn-sm p-1"
                onClick={handleCancelEdit}
                disabled={updateLoading}
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <span>{row.price || "-"}</span>
              {row.usertype === "ADMIN" && row.platform === "PANEL" && (
                <button
                  className="btn btn-outline-primary btn-sm p-1"
                  onClick={() => handlePriceEdit(row._id, row.price)}
                  style={{ fontSize: "12px" }}
                >
                  <i className="bi bi-pencil"></i>
                </button>
              )}
            </div>
          )
        ) : (
          <div>{row.price || "-"}</div>
        ),
      sortable: true,
      width: "180px",
    },



    ...(activeTab === "open"
      ? [
        {
  name: "Live Price",
  selector: (row) => prices?.[row.symbol]?.spot_price,
  cell: (row) => {
    const live = prices?.[row.symbol]?.spot_price;

    return live !== undefined ? (
      roundSmart(live, 3)
    ) : (
      <div
        className="spinner-border spinner-border-sm text-success"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  },
  sortable: true,
  width: "150px",
},

        {
          name: "User Name",
          selector: (row) => row.usertype,
          cell: (row) => row?.userData?.UserName || "ADMIN",
          sortable: true,
          width: "130px",
        },
      ]
      : [{
        name: "User Name",
        selector: (row) => row.usertype,
        cell: (row) => row?.userInfo?.UserName || "ADMIN",
        sortable: true,
        width: "130px",
      },]),
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      cell: (row) => <div>{row.strategy || "-"}</div>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Market Type",
      selector: (row) => row.market_type,
      cell: (row) => row?.market_type || "-",
      sortable: true,
      width: "150px",
    },

  
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => row?.platform || "-",
      sortable: true,
      width: "130px",
    },


    ...(activeTab === "open"
      ? [

        {
          name: "Actions",
          selector: (row) => row._id,
          cell: (row) => (
            <div>
              {row.usertype == "ADMIN" && (
                <i
                  className="fa fa-trash text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDeleteOrder(row._id)}
                ></i>
              )}
            </div>
          ),
          sortable: true,
        },
      ]
      : []),
  ];

  // Fetch orders
  const fetchAllOrders = async () => {
    try {
      const response = await getOrders({ fromDate, toDate });
      if (response?.status) {
        setOriginalData(response.data);
        setAvailableStrategies(extractStrategies(response.data));
        setAvailableUsers(extractUsers(response.data));


        const filtered = applyFilters(response.data, searchInput, strategy);

        setOrdersData({ loading: false, data: filtered });

     
      } else {
        setOrdersData({ loading: false, data: [] });
        setOriginalData([]);

        setAvailableStrategies([]);
      }
    } catch (err) {
      setOrdersData({ loading: false, data: [] });
      setOriginalData([]);

      setAvailableStrategies([]);
    }
  };

  const fetchOpenOrders = async () => {
    try {
      const response = await getOpenOrders({ fromDate, toDate });
      if (response?.status) {
        setOriginalData(response.data);
        setAvailableStrategies(extractStrategies(response.data));
        setAvailableUsers(extractUsers(response.data));


        const filtered = applyFilters(response.data, searchInput, strategy);

        setOrdersData({ loading: false, data: filtered });
      } else {
        setOrdersData({ loading: false, data: [] });
        setOriginalData([]);

        setAvailableStrategies([]);
      }
    } catch (err) {
      setOrdersData({ loading: false, data: [] });
      setOriginalData([]);

      setAvailableStrategies([]);
    }
  };

  useEffect(() => {
    setOrdersData((prev) => ({ ...prev, loading: true }));
    if (activeTab === "all") fetchAllOrders();
    else if (activeTab === "open") fetchOpenOrders();
  }, [activeTab, fromDate, toDate, refresh]);

useEffect(() => {
  const filtered = applyFilters(originalData, searchInput, strategy, selectedUser);

  setOrdersData((prev) => ({ ...prev, data: filtered }));


}, [searchInput, strategy, selectedUser, originalData]);




  const handleDeleteOrder = async (orderId) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteOrder({ orderId });
          if (response?.status) {
            Swal.fire("Deleted!", "Your order has been deleted.", "success");
            setRefresh((prev) => !prev);
          } else {
            console.error("Failed to delete order:", response?.message);
          }
        } else {
          Swal.fire("Cancelled", "Your order is safe :)", "error");
        }
      });
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };

  useEffect(() => {
    setStrategy("");
  }, [activeTab]);

  const handleChange = (date) => {
    // 👇 return karega format YYYY-MM-DD
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };
  return (
    <>
      <Content
        Page_title="All Orders"
        button_status={false}

      >
        <div className="row align-items-end rounded mb-md-3 mb-2 filter-row">
          {/* Search */}
          <div className="col-md-2 col-6">
            <label className="form-label mb-1">Search</label>
            <input
              type="text"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="form-control"
            />
          </div>
          {/* User Name */}
          <div className="col-md-2 col-6">
            <label className="form-label mb-1">User Name</label>
            <select
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              className="form-control"
            >
              <option value="">All Users</option>
              {availableUsers.map((user, index) => (
                <option key={index} value={user}>
                  {user}
                </option>
              ))}
            </select>
          </div>


          {/* From Date */}
          <div className="col-md-2 col-6">
            <label className="form-label mb-1">From Date</label>
            <DatePicker
              selected={fromDate ? new Date(fromDate) : null}
              onChange={(date) => setFromDate(handleChange(date))}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select date"
              className="form-control"
            />
          </div>

          {/* To Date */}
          <div className="col-md-2 col-6">
            <label className="form-label mb-1">To Date</label>
            <DatePicker
              selected={toDate ? new Date(toDate) : null}
              onChange={(date) => setToDate(handleChange(date))}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select date"
              className="form-control"
              minDate={fromDate ? new Date(fromDate) : null}
            />
          </div>

          {/* Strategy */}
          <div className="col-md-3 col-6">
            <label className="form-label mb-1">Strategy</label>
            <select
              value={strategy}
              onChange={(e) => setStrategy(e.target.value)}
              className="form-control"
            >
              <option value="">All Strategies</option>
              {availableStrategies.map((strategyOption, index) => (
                <option key={index} value={strategyOption}>
                  {strategyOption}
                </option>
              ))}
            </select>
          </div>



          {/* Refresh Button */}
          <div className="col-md-1 col-12 d-flex">
            <button
              className="btn btn-primary mt-3"
              onClick={() => {
                setSearchInput("");
                setStrategy("");
                setFromDate(null);
                setToDate(null);
                setActiveTab("all");
                setRefresh((prev) => !prev);
              }}
            >
              <i className="fa fa-refresh"></i>
            </button>
          </div>

        </div>

        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "all" ? "active" : ""}`}
              onClick={() => setActiveTab("all")}
              style={{ cursor: "pointer" }}
            >
              All Orders
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "open" ? "active" : ""}`}
              onClick={() => setActiveTab("open")}
              style={{ cursor: "pointer" }}
            >
              Pending Orders
            </a>
          </li>
        </ul>

        <div className="mt-3">
          {ordersData.loading ? (
            <Loader />
          ) : (
            <Table columns={columns} data={ordersData?.data || []} />
          )}
        </div>
      </Content>
    </>
  );
};

export default Orders;
